(function () {

    'use strict';

    function parseArgs(args) {
        var obj = {},
            inc = 0,
            len = args.length;

        for (inc; inc < len; inc += 1) {
            obj['arg' + inc] = args[inc];
        }

        return obj;
    }

    function create_link() {
        if (typeof arguments[0] == 'object') {
            var o_data = arguments[0];
        }
        else {
            var o_data = parseArgs(arguments);
        }
        var s_resp = arguments[0];

        var xhr = new XMLHttpRequest();
        var params = new URLSearchParams(o_data).toString();
        xhr.open('GET', path_relative_root + 'ajax_createlink.php?' + params, false);
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
            s_resp = xhr.responseText;
            }
        };
        xhr.send();

        return s_resp;
    }

    window.create_link = create_link;

    /*
    * Home cover module
    */
    if (document.querySelector('.cover-module')) {
        const slides = document.querySelectorAll('.cover-module .swiper-slide');
        if (slides.length > 1) {
            const coverSwiper = new Swiper('.cover-module .swiper', {
                pagination: {
                    el: '.cover-pagination',
                }
            });
        }
    }

    /* Preheader swiper */
    if (document.querySelector('.pre-header.swiper-container')) {
        new Swiper('.pre-header.swiper-container', {
            loop: true,
            autoplay: {
                delay: 5000,
            },
            speed: 800,
        });
    }

    if (document.querySelector('.close-pre-header')) {
        document.querySelector('.close-pre-header').addEventListener('click', function () {
            document.body.classList.remove('hasProEHeader');
            const preHeader = document.querySelector('.pre-header');
            if (preHeader) {
                preHeader.remove();
            }
        });
    }

    /*
     * Disable redirection on the address form when logged into the account
    */
    var addNewAddressBtn = document.querySelector('.add_new_address');
    var modifyAddressBtn = document.querySelector('.modlinks_wrapper .modify');

    if (addNewAddressBtn) {
        document.querySelectorAll('.add_new_address').forEach(function (btn) {
            btn.addEventListener('click', function (event) {
                event.preventDefault();
            });
        });
    }

    if (modifyAddressBtn) {
        document.querySelectorAll('.modlinks_wrapper .modify').forEach(function (btn) {
            btn.addEventListener('click', function (event) {
                event.preventDefault();
            });
        });
    }

    document.querySelectorAll('.order_filter').forEach(function(btn) {
        btn.addEventListener('click', function() {
            document.querySelectorAll('.order_filter').forEach(function(otherBtn) {
                if (otherBtn !== btn) {
                    otherBtn.removeAttribute('is-selected');
                }
            });
            btn.setAttribute('is-selected', '');
            var target = btn.getAttribute('data-orderfilter');
            var typeActif = document.getElementById('type_actif');
            if (typeActif) {
                typeActif.value = target;
            }

            const evt = new CustomEvent('filterSelected');
            window.dispatchEvent(evt);
        });
    });

    checkWishProductStock();
    hideLegalNoticesLinkIfEmpty();
}());

$(function () {
    // If select2 is not loaded, exit to avoid an undefined error
    if (typeof $.fn.select2 === 'undefined') {
        return;
    }

    // Country select init with select2
    $('#countries_select').select2({
        width: 'resolve',
        placeholder: Translator.translate('choose_country'),
        templateResult: function (data) {
            if (!data.id) {
                return data.text;
            }

            const $option    = $(data.element);
            const countryId  = $option.data('country-id');

            const $node = $('<span></span>');
            $node.text(data.text);
            $node.attr('data-country-id', countryId);

            return $node;
        },
        templateSelection: function (data) {
            if (!data.id) {
                return data.text;
            }

            const $option    = $(data.element);
            const countryId  = $option.data('country-id');

            const $node = $('<span></span>');
            $node.text(data.text);
            $node.attr('data-country-id', countryId);

            return $node;
        },
    });
    $('#countries_select').on('select2:open', function () {
        const $search = $('.select2-container .select2-search__field');
        $search.attr('placeholder', Translator.translate('search_country_placeholder'));
        setTimeout(function () {
            $search.trigger('focus');
        }, 100);
    });
    $('#country_langs_select').select2({
        minimumResultsForSearch: -1,
        width: 'resolve',
    });

    // Manage FP back button on mobile product page
    $(document).on('click', '.return-link-anchor', handleMobileProductBack);
});

function handleMobileProductBack(event) {
    event.preventDefault();

    var hasInternalHistory = false;

    if (window.history.length > 1 && document.referrer) {
        try {
            hasInternalHistory = new URL(document.referrer).origin === window.location.origin;
        } catch (error) {
            hasInternalHistory = false;
        }
    }

    if (hasInternalHistory) {
        window.history.back();
        return;
    }

    var breadcrumbLinks = document.querySelectorAll('.breadcrumbs a');
    var objectLevelLink = breadcrumbLinks[breadcrumbLinks.length - 1];

    if (objectLevelLink) {
        window.location.assign(objectLevelLink.href);
        return;
    }

    var homeUrl = typeof path_relative_root !== 'undefined' && path_relative_root
        ? path_relative_root
        : '/';

    window.location.assign(homeUrl);
}

function isInViewport(element) {
    // Accepts HTMLElement or jQuery object
    const el = element instanceof HTMLElement ? element : element[0];
    if (!el) return false;

    const rect = el.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowTop = 0;
    const windowBottom = windowHeight;

    return rect.bottom > windowTop && rect.top < windowBottom;
}

function copyToClipboard(textToCopy) {
    const textAreaCopy = function() {
        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        // make the textarea almost invisible but keep it selectable on mobile browsers
        textArea.style.position = "fixed";
        textArea.style.left = "0";
        textArea.style.top = "0";
        textArea.style.width = "1px";
        textArea.style.height = "1px";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        textArea.setSelectionRange(0, textArea.value.length);

        return new Promise((res, rej) => {
            // here the magic happens
            let copied = false;

            try {
                copied = document.execCommand('copy');
            } catch (error) {
                textArea.remove();
                rej(error);
                return;
            }

            textArea.remove();
            copied ? res() : rej(new Error('Unable to copy text with execCommand'));
        });
    };

    return textAreaCopy().then(function() {
        // create a temporary element to display a message
        const temp = document.createElement("div");
        temp.textContent = Translator.translate('text_copied');
        temp.className = "copied-text-notification";
        const cartRecapTitle = document.querySelector('.cart-recap-title');

        if (!cartRecapTitle) {
            return;
        }

        cartRecapTitle.appendChild(temp);

        setTimeout(function() {
            const copiedTextNotification = document.querySelector(".copied-text-notification");
            if (copiedTextNotification) {
                copiedTextNotification.setAttribute("slide-out", "");
            }
        }, 3500);

        setTimeout(function() {
            const copiedTextNotification = document.querySelector(".copied-text-notification");
            if (copiedTextNotification) {
                copiedTextNotification.remove();
            }
        }, 4000);
    }).catch(function(error) {
        console.error('Unable to copy text to clipboard', error);
    });
}

function invokeNativeShare(url) {
    if (!isUrlValid(url)) {
        url = 'https://' + url;
    }
    if (navigator.share) {
        navigator.share({
            url: url
        }).then(() => {

        })
        .catch(console.error);
    } else {
        // if web api is not supported, fallback to copy to clipboard
        copyToClipboard(url);
    }
}

function setAddFormProductHeight() {
    const formWrapper = document.querySelector('.product-form');
    const form = document.querySelector('.productsheet-form');

    formWrapper.style.height = form.offsetHeight + 'px';
}

if (document.querySelector('body.product_page')) {
    window.addEventListener('DOMContentLoaded', setAddFormProductHeight);
    window.addEventListener('resize', setAddFormProductHeight);
    // add a mutation observer to watch for changes in the form height (useful for layout shifts of the Unify Widget)
    const formProductResizeObserver = new ResizeObserver(() => {
        setAddFormProductHeight();
    });
    formProductResizeObserver.observe(document.querySelector('.productsheet-form'));
}

function loadLazyImage(img) {
    if (!img || img.hasAttribute('lazy-loaded')) return;

    const dataSrc = img.getAttribute('data-src');
    if (dataSrc) {
        img.setAttribute('src', dataSrc);
        img.removeAttribute('data-src');
    }
    img.setAttribute('lazy-loaded', '');
}

function loadLazyItemInteraction(element) {
    if (!element || element.hasAttribute('lazy-loaded')) return;

    const dataBgColor = element.getAttribute('data-item-int-color');
    const dataBgImage = element.getAttribute('data-item-int-image');

    if (dataBgColor) {
        element.style.backgroundColor = dataBgColor;
        element.removeAttribute('data-item-int-color');
    } else if (dataBgImage) {
        element.style.backgroundImage = `url('${dataBgImage}')`;
        element.removeAttribute('data-item-int-image');
    }
    element.setAttribute('lazy-loaded', '');
}

function loadLazyProductColor(element) {
    if (!element || element.hasAttribute('lazy-loaded')) return;

    const dataBgImage = element.getAttribute('data-prod-color-img');

    if (dataBgImage) {
        element.style.backgroundImage = `url('${dataBgImage}')`;
        element.removeAttribute('data-prod-color-img');
    }
    element.setAttribute('lazy-loaded', '');
}

let lazyObserver;
let lazyFallbackInitialized = false;

function observeLazyImages() {
    const lazyImages = document.querySelectorAll('img[is-lazy]:not([lazy-loaded])');
    const lazyItemInteractions = document.querySelectorAll('[is-lazy-item-int]:not([lazy-loaded])');
    const lazyProductColors = document.querySelectorAll('[is-lazy-prod-color]:not([lazy-loaded])');

    if ('IntersectionObserver' in window) {
        if (!lazyObserver) {
            lazyObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const element = entry.target;
                        if (element.tagName === 'IMG') {
                            loadLazyImage(element);
                        } else if (element.hasAttribute('is-lazy-item-int')) {
                            loadLazyItemInteraction(element);
                        } else if (element.hasAttribute('is-lazy-prod-color')) {
                            loadLazyProductColor(element);
                        }
                        observer.unobserve(element);
                    }
                });
            }, {
                root: null,
                threshold: 0,
                // add a 400px root margin only if we're on the product page
                rootMargin: document.body.classList.contains('product_page') ? '400px 0px' : '0px'
            });
        }

        lazyImages.forEach(img => lazyObserver.observe(img));
        lazyItemInteractions.forEach(el => lazyObserver.observe(el));
        lazyProductColors.forEach(el => lazyObserver.observe(el));
    } else {
        // Fallback for browsers without IntersectionObserver
        function fallbackHandler() {
            document
                .querySelectorAll('img[is-lazy]:not([lazy-loaded])')
                .forEach(img => {
                    if (isInViewport(img)) {
                        loadLazyImage(img);
                    }
                });

            document
                .querySelectorAll('[is-lazy-item-int]:not([lazy-loaded])')
                .forEach(el => {
                    if (isInViewport(el)) {
                        loadLazyItemInteraction(el);
                    }
                });

            document
                .querySelectorAll('[is-lazy-prod-color]:not([lazy-loaded])')
                .forEach(el => {
                    if (isInViewport(el)) {
                        loadLazyProductColor(el);
                    }
                });
        }

        if (!lazyFallbackInitialized) {
            lazyFallbackInitialized = true;
            fallbackHandler(); // Initial check
            window.addEventListener('scroll', fallbackHandler, { passive: true });
            window.addEventListener('resize', fallbackHandler);
            window.addEventListener('orientationChange', fallbackHandler);
        } else {
            fallbackHandler();
        }
    }
}

document.addEventListener("DOMContentLoaded", function() {
    observeLazyImages(); // Initial observation on page load

    document.addEventListener("search_getProducts_end", observeLazyImages);

    [
        'refreshCart_complete',
        'removeFromBasket_success',
        'changeQteBasket_success',
        'basketToWish_success',
        'wishToBasket_success',
        'search_success',
        'newProductBlocGenerated',
    ].forEach(eventName => {
        window.addEventListener(eventName, observeLazyImages);
    });

    ['newBlocGenerated', 'filterSelected', 'newBlocSearchGenerated'].forEach(eventName => {
        window.addEventListener(eventName, function() {
            initializeItemSliders();
            observeLazyImages();
        });
    });

    window.addEventListener('newFilterSearchGenerated', function() {
        document.querySelectorAll('.item-visuals').forEach((slider) => {
            if (slider.swiper) {
                slider.swiper.destroy();
            }
            //slide.classList.remove('swiper-initialized');
        });
        setTimeout(() => {
            initializeItemSliders();
            observeLazyImages();
        }, 250);
    });

    document.addEventListener("search_onSearchEnd_end",
        function(event) {
            observeLazyImages();

            initTgSwiper(5.75); // 5.75 = number of items visible in the tg module on search page

            initCategoryTopSlider();

            getWishlistProducts();

            initializeItemSliders();
        }
    );

    // Get products in wishlist when item-product is present
    if (document.querySelector('.item-product')) {
        setTimeout(() => {
            getWishlistProducts();
        }, 1000);
    }

    // Open filters modal on filter trigger click
    document.addEventListener('click', function (e) {
        if (e.target && e.target.id === 'filter-trigger') {
            openModal('filters-modal', 'above');
        }
    });

    setTimeout(() => {
        // Show popin fairlymade
        const fairlyBtn = document.getElementById("fairly-trigger");

        if (fairlyBtn) {
            fairlyBtn.addEventListener("click", function() {
                openMultiShad("popup-fairlymade");

                if (is_mobile) {
                    document.body.setAttribute("has-scroll-locked", "");
                }
            });

            if (is_mobile) {
                document.querySelector('.modal-backdrop').addEventListener('click', function () {
                    if (document.getElementById('popup-fairlymade').hasAttribute('modal-open')) {
                        document.body.removeAttribute("has-scroll-locked");
                    }
                });
            }
        }

        // Close popin fairlymade
        const closeBtn = document.getElementById("close_fairlymade_wrapper");

        if (closeBtn) {
            closeBtn.addEventListener("click", function(event) {
                event.stopPropagation();
                closeMultiShad("popup-fairlymade");

                if (is_mobile) {
                    document.body.removeAttribute("has-scroll-locked");
                }
            });
        }
    }, 500);

    // Addd loading state on all btn-submits
    document.querySelectorAll('.btn-submit:not([is-express])').forEach(function(btn) {
        btn.addEventListener('click', function() {
            btn.setAttribute('is-loading', '');

            if (btn.classList.contains('modal-purchase-confirmation')) {
                window.location.href = path_relative_root + create_link('order_basket');
            }

            setTimeout(() => {
                btn.removeAttribute('is-loading');
            }, 3000);
        });
    });
});

/**
 * Sets multiple attributes on a given DOM element.
 * Ex : setAttributes(button, {
        class: "btn btn-primary",
        type: "button",
        "data-action": "save"
    });
 */
function setAttributes(el, attrs) {
    for (const key in attrs) {
        el.setAttribute(key, attrs[key]);
    }
}

/**
 * Removes multiple attributes from a given DOM element.
 * Ex : removeAttributes(document.querySelector('button'), ["class", "type", "data-action"]);
 */
function removeAttributes(el, attrs) {
    attrs.forEach(attr => el.removeAttribute(attr));
}

const BackdropManager = (() => {
    const backdrop = document.querySelector('.modal-backdrop');
    if (!backdrop) return null;

    const reasons = new Set();
    let aboveCount = 0;

    function render() {
        if (reasons.size > 0) {
            if (!backdrop.hasAttribute('is-visible')) {
                backdrop.setAttribute('is-visible', '');
            }
        } else {
            backdrop.removeAttribute('is-visible');
            backdrop.removeAttribute('position-above');
        }

        if (aboveCount > 0) {
            backdrop.setAttribute('position-above', '');
        } else {
            backdrop.removeAttribute('position-above');
        }
    }

    return {
        show(reason, options = {}) {
            if (!reason) return;
            reasons.add(reason);

            if (options.position === 'above') {
                aboveCount++;
            }

            render();
        },

        hide(reason) {
            if (!reason) return;

            if (reasons.has(reason)) {
                reasons.delete(reason);
            }

            // sécurité
            aboveCount = Math.max(0, aboveCount - 1);

            render();
        },

        reset() {
            reasons.clear();
            aboveCount = 0;
            render();
        },

        isVisible() {
            return reasons.size > 0;
        }
    };
})();

function toggleBackdrop(isVisible, position) {
    const modalBackdrop = document.querySelector('.modal-backdrop');
    if (!modalBackdrop) return;

    const visible = modalBackdrop.hasAttribute('is-visible');

    if (isVisible) {
        if (!visible) modalBackdrop.setAttribute('is-visible', '');

        if (position === 'above') {
            if (!modalBackdrop.hasAttribute('position-above')) {
                modalBackdrop.setAttribute('position-above', '');
            }
        } else {
            if (modalBackdrop.hasAttribute('position-above')) {
                modalBackdrop.removeAttribute('position-above');
            }
        }
    } else {
        if (visible) modalBackdrop.removeAttribute('is-visible');
        if (modalBackdrop.hasAttribute('position-above')) {
            modalBackdrop.removeAttribute('position-above');
        }
    }
}

function checkWishProductStock() {
    const topWishlist = document.querySelector('.top-wishlist');
    if (!topWishlist) return;

    const allProducts = topWishlist.querySelectorAll('.rollover-basket-product');
    if (allProducts.length === 0) return;

    const allOutOfStock = Array.from(allProducts).every(product =>
        product.querySelector('.rollover-wishlist-no-stock')
    );

    if (allOutOfStock) {
        topWishlist.setAttribute('all-out-of-stock', '');
    } else {
        topWishlist.removeAttribute('all-out-of-stock');
    }

    return allOutOfStock;
}

/**
 * Native JS Password validator for non-Vue forms
 * Adds a password validator to all input elements with the `data-pwd-creation` attribute.
 * The validator checks for the following password requirements based on the configuration:
 * - Lowercase letters
 * - Uppercase letters
 * - Digits
 * - Special characters
 * - Minimum length
 *
 * The validator displays a list of requirements and a progress bar indicating the password strength.
 *
 * Configuration is expected to be available in `window.password_validator_config` with the following properties:
 * - lowercase: {boolean} - Whether to check for lowercase letters.
 * - uppercase: {boolean} - Whether to check for uppercase letters.
 * - digit: {boolean} - Whether to check for digits.
 * - special: {boolean} - Whether to check for special characters.
 * - min_length: {number} - Minimum length of the password (if not defined, we don't check for password length
 *
 * The function also uses a global `Translator` object to translate text.
 */
function addPasswordValidator() {
    // Find all input elements with data-pwd-creation attribute
    const pwdInputs = document.querySelectorAll('input[data-pwd-creation]');

    let passwordValidatorConfig = window.password_validator_config;

    pwdInputs.forEach(input => {
        // Create the validator element
        const validator = document.createElement('div');
        validator.className = 'w-class-pwd-creation';
        validator.style.display = 'none';

        // Set the HTML content for the validator
        let validatorHtml = `
            <h3>${Translator.translate('pwd_must_contain')}</h3>
            <ul>`;

        if (passwordValidatorConfig.lowercase == true) {
            validatorHtml += `<li id="letter" class="w-pwd-req w-pwd-req-error">${Translator.translate('pwd_lower_case')}</li>`;
        }

        if (passwordValidatorConfig.uppercase == true) {
            validatorHtml += `<li id="capital" class="w-pwd-req w-pwd-req-error">${Translator.translate('pwd_upper_case')}</li>`;
        }

        if (passwordValidatorConfig.digit == true) {
            validatorHtml += `<li id="number" class="w-pwd-req w-pwd-req-error">${Translator.translate('pwd_number')}</li>`;
        }

        if (passwordValidatorConfig.special == true) {
            validatorHtml += `<li id="special" class="w-pwd-req w-pwd-req-error">${Translator.translate('pwd_special_char')}</li>`;
        }

        validatorHtml += `
                <li id="length" class="w-pwd-req w-pwd-req-error">${Translator.translate('pwd_length')}</li>
            </ul>
            <h3>${Translator.translate('pwd_security')} <span class="security-level">${Translator.translate('pwd_security_text_0')}</span></h3>
            <progress value="0" max="100" class="w-pwd-strength strength-0"></progress>
            <p>${Translator.translate('pwd_security_text')}</p>
        `;

        validator.innerHTML = validatorHtml;

        // Insert the validator after the input
        input.parentNode.appendChild(validator);

        // Add event listeners
        input.addEventListener('input', updateValidator);
        input.addEventListener('focus', () => {
            validator.style.display = 'block';
            input.classList.add('w-focused');

            handleInput(input);
        });
        input.addEventListener('blur', () => {
            validator.style.display = 'none';
            input.classList.remove('w-focused');

            handleInput(input);
        });

        /**
         * Updates the password validator UI based on the current input value.
         *
         * This function checks the password against various criteria such as:
         * - Lowercase letters
         * - Uppercase letters
         * - Numbers
         * - Special characters
         * - Minimum length
         *
         * It updates the UI to reflect which criteria are met and adjusts the security level accordingly.
         */
        function updateValidator() {
            const password = input.value;
            let securityLevel = 0;
            let nbValidation = 1;

            // Check lowercase letters
            if (passwordValidatorConfig.lowercase == true) {
                nbValidation++;
                if (password.match(/[a-z]/g)) {
                    validator.querySelector('#letter').classList.remove('w-pwd-req-error');
                    securityLevel++;
                } else {
                    validator.querySelector('#letter').classList.add('w-pwd-req-error');
                }
            }

            // Check uppercase letters
            if (passwordValidatorConfig.uppercase == true) {
                nbValidation++;
                if (password.match(/[A-Z]/g)) {
                    validator.querySelector('#capital').classList.remove('w-pwd-req-error');
                    securityLevel++;
                } else {
                    validator.querySelector('#capital').classList.add('w-pwd-req-error');
                }
            }

            // Check numbers
            if (passwordValidatorConfig.digit == true) {
                nbValidation++;
                if (password.match(/[0-9]/g)) {
                    validator.querySelector('#number').classList.remove('w-pwd-req-error');
                    securityLevel++;
                } else {
                    validator.querySelector('#number').classList.add('w-pwd-req-error');
                }
            }

            // Check special characters
            if (passwordValidatorConfig.special == true) {
                nbValidation++;
                if (password.match(/[!@#$%^&*]/g)) {
                    validator.querySelector('#special').classList.remove('w-pwd-req-error');
                    securityLevel++;
                } else {
                    validator.querySelector('#special').classList.add('w-pwd-req-error');
                }
            }

            // Check length
            let minLengthPwd = passwordValidatorConfig.min_length || 0;
            if (password.length >= minLengthPwd) {
                validator.querySelector('#length').classList.remove('w-pwd-req-error');
                securityLevel++;
            } else {
                validator.querySelector('#length').classList.add('w-pwd-req-error');
            }

            // Update security level
            const securityLevelEl = validator.querySelector('.security-level');
            securityLevelEl.textContent = Translator.translate(`pwd_security_text_${securityLevel}`);

            const progressBar = validator.querySelector('progress');
            if (nbValidation > 0) {
                nbValidation = 100/nbValidation;
            }
            progressBar.value = securityLevel * nbValidation;
            progressBar.className = `w-pwd-strength strength-${securityLevel}`;
        }
    });
}

// when the dom is ready, check displayPasswordValidator and if it's true, add the password validator
document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.password_validator_config != "undefined" && typeof window.password_validator_config.enable != "undefined" && window.password_validator_config && window.password_validator_config.enable) {
        addPasswordValidator();
    }
});

function handleInput(input) {}
function toggleVisibilityPassword(button, target) {}

function afficheLostPassword(event) {

    event.preventDefault();

    const subtitleLogin = document.getElementById('subtitleLogin');
    const subtitlePassword = document.getElementById('subtitlePassword');
    const newLoginForm = document.querySelector('.w-newlogin-form');
    const lostPassForm = document.querySelector('.w-lostpass-form');

    slideUp(subtitleLogin, 500);
    slideUp(newLoginForm, 500);
    slideDown(subtitlePassword, 500);
    slideDown(lostPassForm, 500);
}

function reloadBlocLogin(event) {

    event.preventDefault();

    const subtitleLogin = document.getElementById('subtitleLogin');
    const subtitlePassword = document.getElementById('subtitlePassword');
    const lostPassForm = document.querySelector('.w-lostpass-form');
    const newLoginForm = document.querySelector('.w-newlogin-form');

    slideUp(lostPassForm, 500);
    slideUp(subtitlePassword, 500);
    slideDown(subtitleLogin, 500);
    slideDown(newLoginForm, 500, 'grid');
}

/*
 * User deconnexion from top rollover
 * ATTENTION: uses non-asynchronous XMLHttpRequest to keep the loading state visible
 */
function userDisconnection() {

    const accountUrls = [
        create_link('client_myinfos'),
        create_link('client_addresses'),
        create_link('client_commandes'),
        create_link('stock_alert'),
        create_link('paymentOption'),
        create_link('wishlist'),
        create_link('newsletter_subscription')
    ];

    const currentUrl = window.location.pathname;

    const isAccounttUrl = accountUrls.some(url => currentUrl.includes(url));

    try {
        // Do not use XMLHttpRequest on other requests, we only use it here to keep the loading state visible
        const xhr = new XMLHttpRequest();
        // false makes it synchronous, so the loading state is visible
        xhr.open("GET", path_relative_root + "ajax_deconnect.php", false);
        xhr.send(null);

        if (xhr.status >= 200 && xhr.status < 300) {
            if (isAccounttUrl) {
                window.location.assign(path_relative_root + 'connexion.php');
            } else {
                window.location.reload();
            }
        } else {
            document.querySelector('.btn-disconnect').removeAttribute('is-loading');
        }
    } catch (e) {
        document.querySelector('.btn-disconnect').removeAttribute('is-loading');
    }
}

async function deleteStockAlert() {
    const productId = this.getAttribute('data-product-id');
    const colorId = this.getAttribute('data-color-id');
    const sizeId = this.getAttribute('data-size-id');
    const newsletterId = this.getAttribute('data-newsletter-id');

    const response = await fetch(path_relative_root + 'ajax_delete_stock_alert.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `productId=${encodeURIComponent(productId)}&colorId=${encodeURIComponent(colorId)}&sizeId=${encodeURIComponent(sizeId)}&newsletterId=${encodeURIComponent(newsletterId)}`
    });
    const result = await response.json();
    if (result.success === true) {
        // Remove the alert element from the DOM
        let productLink = this.closest('.alert-item-wrapper');
        if (productLink) productLink.remove();
    } else {
        alert(Translator.translate('alert_stock_delete_impossible'));
    }
}

/* Vanilla JS slideDown method */
function slideDown(element, duration = 300, display = 'block') {
    element.style.display = display;

    const height = element.scrollHeight; // final height

    element.style.overflow = 'hidden';
    element.style.height = '0px';
    element.offsetHeight; // force reflow

    element.style.transition = `height ${duration}ms ease`;
    element.style.height = height + 'px';

    function end() {
        element.style.display = display;
        element.style.height = 'auto'; // free after animation
        element.style.overflow = 'visible';
        element.removeAttribute('is-collapsed');
        element.setAttribute('is-displayed', '');
        element.removeEventListener('transitionend', end);
    }
    element.addEventListener('transitionend', end);
}

/* Vanilla JS slideUp method */
function slideUp(element, duration = 300) {
    element.style.height = element.scrollHeight + 'px';
    element.style.overflow = 'hidden';
    element.offsetHeight; // force reflow

    element.style.transition = `height ${duration}ms ease`;
    element.style.height = '0px';

    function end() {
        element.style.display = 'none';
        element.style.overflow = 'visible';
        element.removeAttribute('is-displayed');
        element.setAttribute('is-collapsed', '');
        element.removeEventListener('transitionend', end);
    }
    element.addEventListener('transitionend', end);
}

function openMultiShad(id, position) {
    if (!id) return;

    openModal(id, position ? position : null);
}

function closeMultiShad(id, position) {
    if (!document.getElementById(id)) return;

    closeModal(id, position ? position : null);
}

function openModal(id, position) {
    if (!document.getElementById(id)) return;

    document.getElementById(id).setAttribute('modal-open', '');
    document.querySelector('header').setAttribute('customisation-hover-state', '');
    toggleBackdrop(1, position ? position : null);

    if (id != "country_switcher_lightbox") {
        document.querySelector('.modal-backdrop').addEventListener('click', function () {
            closeModal(id, position ? position : null);
        });
    }

    if (id === 'product-zoom') {
        initFpVisualsZoom();

        document.querySelectorAll('.product-visual-zoom .swiper-slide').forEach(function (slide) {
            slide.addEventListener('mousemove', function (event) {
                var slideRect = slide.getBoundingClientRect();
                var img = slide.querySelector('img');

                if (img) {
                    // Mouse position inside swiper-slide (0 on top → 1 on bottom)
                    var relY = (event.clientY - slideRect.top) / slideRect.height;
                    // Height in excess of the image compared to the slide
                    var overflow = img.offsetHeight - slideRect.height;
                    // Move the image based on the ratio, from 0px to -overflow
                    var top = -relY * overflow;
                    img.style.top = top + "px";
                }
            });
        });

        setTimeout(() => {
            document.querySelector('.product-visuals-zoom').setAttribute('zoom-initialized', '');

            if (document.querySelector('.double-tap-msg')) {
                setTimeout(() => {
                    document.querySelector('.double-tap-msg').setAttribute('is-hidden', '');
                }, 2000);
            }
        }, 0);
    }

    if (id === "country_switcher_lightbox" || id === "exit_overlay_OVI") {
        if (document.querySelector('.rollover-menu-wrapper').hasAttribute('is-displayed')) {
            document.body.removeAttribute("has-scroll-locked");
            document.querySelector(".burger-menu").removeAttribute("is-open");

            if (document.body.classList.contains("homepage") && window.scrollY <= 1) {
                document.querySelector("header").setAttribute("customization-transparent-state", "");
            } else if (window.scrollY > 1) {
                document.querySelector("header").setAttribute("customization-scroll-state", "");
            }

            document.querySelector("header").removeAttribute("menu-open");
            removeAttributes(document.querySelector(".rollover-menu-wrapper"), ["is-displayed", "is-boutique"]);
        }

        // Set the body to has-scroll-locked to prevent scroll
        document.body.setAttribute("has-scroll-locked", "");
    }
}

function closeModal(id, position) {
    if (!document.getElementById(id)) return;

    document.getElementById(id).removeAttribute('modal-open');
    document.querySelector('header').removeAttribute('customisation-hover-state');

    const modalIds = [
        'exit_overlay_OVI',
        'country_switcher_lightbox',
        'delivery_home_choice',
    ];

    // Check if any of the modals that require backdrop to be visible are still open, if not hide the backdrop
    const isAnyModalOpen = modalIds.some((id) => {
        const el = document.getElementById(id);
        return el && el.hasAttribute('modal-open');
    });

    if (!isAnyModalOpen) {
        toggleBackdrop(0, position ?? null);
    }

    if (id === "exit_overlay_OVI") {
        // Remove the scroll lock on body
        document.body.removeAttribute("has-scroll-locked");
    }

    if (id === "country_switcher_lightbox") {
        // Remove the scroll lock on body
        document.body.removeAttribute("has-scroll-locked");

        fetch(path_relative_root + "ajax_set_session_country_code.php", {
            method: "POST",
            headers: {
            "Content-Type": "application/x-www-form-urlencoded"
            },
            body: "value=" + encodeURIComponent(document.querySelector('.country_initials').innerHTML.toUpperCase())
        });
    }

    if (id === 'product-zoom') {
        if (document.querySelector('.double-tap-msg')) {
            document.querySelector('.double-tap-msg').removeAttribute('is-hidden');
        }
    }
    // Fire a custom event to notify that the modal has been closed
    const event = new CustomEvent('closeModal', { detail: { modalId: id, position: position } });
    document.dispatchEvent(event);
}

/**
 * Hide legal notice link in footer
 */
function hideLegalNoticesLinkIfEmpty() {
    if (!document.querySelector('.col_links')) return;

    let content = document.querySelector('#modal-legal-mentions .modal-content');
    if (!content || content.textContent.trim() !== '') return;

    document.querySelectorAll('.col_links').forEach(button => {
        let onclickAttr = button.getAttribute('onclick');

        if (onclickAttr && onclickAttr.includes("modal-legal-mentions")) {
            button.setAttribute('hidden', '');
        }
    });
}

function validateNewUserTunnelV2(event) {
    if (wShop.$refs.wNewuserFormV2 != undefined) {
        wShop.$refs.wNewuserFormV2.onSubmit(event)
    }
}

// Called in app w-newuser-form-v2 form
function displaytunnelRightLoader(visible) {
    let cartLoader = document.querySelector('.submit-address');

    if (cartLoader) {

        if (visible === true) {

            cartLoader.setAttribute('is-loading', '');
        } else {

            cartLoader.removeAttribute('is-loading');
        }
    }
}

function cartFaqToggle() {
    document.querySelectorAll('.intitule_question').forEach(function(question) {
        question.addEventListener('click', function() {
            document.querySelectorAll('.texte_question[is-displayed]').forEach(function(response) {
                slideUp(response, 300);
            });

            const faqItem = question.nextElementSibling;
            if (faqItem.hasAttribute('is-collapsed')) {
                question.setAttribute('is-open', '');
                slideDown(faqItem, 300);
            } else {
                question.removeAttribute('is-open');
                slideUp(faqItem, 300);
            }
        });
    });
}

if (document.querySelector('.intitule_question')) {
    cartFaqToggle();
}

function initTgSwiper(slidesPerView = 4) {
    document.querySelectorAll('.main-tg-swiper').forEach(swiperEl => {
        new Swiper(swiperEl, {
            slidesPerView: slidesPerView,
            spaceBetween: 12,
            allowTouchMove: false,
            navigation: {
                nextEl: swiperEl.querySelector('.tg-module-next'),
                prevEl: swiperEl.querySelector('.tg-module-prev'),
            }
        });
    });
}

function initCategoryTopSlider() {
    const categoryTopSlider = document.querySelector('#category-top-slider');
    const categoryCurrent = categoryTopSlider.querySelector('.swiper-slide.current');
    const categoryCurrentIndex = categoryCurrent ? Array.from(categoryTopSlider.querySelectorAll('.swiper-slide')).indexOf(categoryCurrent) : 0;

    const categSlider = new Swiper(categoryTopSlider, {
        slidesPerView: 'auto',
        spaceBetween: 15,
        initialSlide: categoryCurrentIndex,
        navigation: {
            nextEl: categoryTopSlider.querySelector('.category-next-slide'),
            prevEl: categoryTopSlider.querySelector('.category-prev-slide'),
        },
    });

    setTimeout(function () {
        categoryTopSlider.setAttribute('is-visible', '');
    }, 0);
}

// Checks if products are in wishlist (rayon, tdg)
function getWishlistProducts() {
    let array_elements = document.querySelectorAll('[data-itemid]');
    let array_ids = [];
    if (typeof array_elements != 'undefined' && array_elements.length > 0) {
        for (el of array_elements) {
            var id = el.getAttribute('data-itemid');
            if (id != '' && id != 'undefined') {
                array_ids.push(id);
            }
        }

        let data = JSON.parse((JSON.stringify(Object.assign({}, array_ids))));

        $.ajax({
            type: 'get',
            url: path_relative_root + 'get_user_all_wishlist.php',
            data: data,
            success: function (response) {
                if (typeof response != 'undefined') {
                    let array_product_id;

                    try {
                        array_product_id = JSON.parse(response);
                    } catch (e) {
                        return;
                    }

                    for (product_wishlist in array_product_id) {
                        if (document.querySelector('.item-product[data-itemid="' + array_product_id[product_wishlist].fk_produit_id + '"]')  && document.querySelector('.item-product[data-itemid="' + array_product_id[product_wishlist].fk_produit_id + '"]').getAttribute('data-itemsize') == array_product_id[product_wishlist].fk_taille_id) {
                            document.querySelector('.item-product[data-itemid="' + array_product_id[product_wishlist].fk_produit_id + '"] .item-wishlist').setAttribute("in-wishlist", ""); // in_wishlist attr is used to notify if item is in wishlist
                        }
                    }
                } else {
                    return;
                }
            }
        });
    }
}

function getCurrentUri(options = {}) {
    const {
        withQuery = false,
        stripLang = true,
        stripBase = true
    } = options;

    const path = window.location.pathname || '/';
    const query = window.location.search || '';
    let uri = withQuery ? (path + query) : path;

    if (stripBase && typeof path_relative_root !== 'undefined' && path_relative_root) {
        const base = String(path_relative_root).replace(/\/+$/, '');
        if (base && base !== '/' && uri.startsWith(base + '/')) {
            uri = uri.slice(base.length);
        }
    }

    if (stripLang) {
        uri = uri.replace(/^\/[a-z]{2}(?:\/[a-z]{2})?\//i, '/');
    }

    if (!uri.startsWith('/')) uri = '/' + uri;

    return uri;
}

function changeLocale(locale, uri, redirect = true, site = 1) {
    if (!uri) {
        uri = getCurrentUri();
    }

    $.ajax({
        url: path_relative_root + "ajax_get_uri_by_lang.php",
        type: "post",
        data: {
            lang: locale,
            url: uri,
            redirect: redirect,
            site: site
        },
        success: function (data) {
            if (data != "") {
                var force = "";
                if (uri == "/") {
                    force = "?force";
                }
                if (redirect) {
                    location.href = data + force;
                } else {
                    urlLang = data;
                }
            }
        },
    });
}


function triggerNavigationDataLayer(event) {
    const target = window.event ? window.event.target : event.target;
    const clickedElement = target.closest('a') || target.closest('[data-path]');

    if (clickedElement) {
        const menuLabel = clickedElement.innerText.trim();
        const menuPath = clickedElement.getAttribute('data-path') || 'no-path';

        // 2. Push to Data Layer
        window.dataLayer = window.dataLayer || [];
        pushToWshopBus({
            'event': 'menu_navigation',
            'menu_item_label': menuLabel,
            'menu_item_path': menuPath,
            'interaction_type': 'click'
        });
    }
}

document.addEventListener("click", function (event) {
    if (!event.target || !event.target.matches("#oneTrustModal")) return;

    OneTrust.ToggleInfoDisplay();
});

function dataLayer_associated_product() {
    var $isAssociation = $(this).closest(".associations-wrapper");
    var $isRecentlyBrowsed = $(this).closest(".recently-browsed-slider");

    if ($isAssociation.length || $isRecentlyBrowsed.length) {

        $('form[id^="prod_info_"]').on('click', function(e) {
            e.stopPropagation();
        });

        var product_id = this.getAttribute('data-prod') || this.getAttribute('data-itemid') || '';

        if (product_id !== '' && typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== null) {

            if ($isAssociation.length) {
                // Logic for Associations
                DataLayerTrigger.selectItem(dl_v3_impressions_like, dlv3_action_fields_like, product_id);
            } else if ($isRecentlyBrowsed.length) {
                // Logic for Recently Browsed
                DataLayerTrigger.selectItem(dl_v3_impressions_visited_products, dlv3_action_fields_visited_products, product_id);
            }
        }
    }
}

// We don't load any script if the constant is not enabled (done in the cache)
if (query_stock_in_cache) {

    // Cache of stock data, keyed by product ID, filled by ajax calls.
    var array_stock_product = [];

    // Tracks current product IDs being fetched, to prevent simultaneous ajax calls for the same product ID
    var pendingProductIds = new Set();
    var res_xhr = null;

    window.addEventListener('updateItemStock', event => updateProductDisplayWithStock(event.detail.productId));
    window.addEventListener('change', event => updateProductDisplayWithStock(null, false, true));
    window.addEventListener('change', event => updateProductDisplayWithStock(null, true));

    // On page load, trigger the initial stock check for all products on the page
    if (document.querySelectorAll('.stockToCheck').length > 0) {
        // On load, gets product stocks by ajax, then updates the display of the products with the event listener above
        updateProductDisplayWithStock(null, true);
    }

    function updateProductDisplayWithStock(productId = null, checkNewItems = false, refreshCurrentItems = false) {
        // Gets the stocks for new products (then updates each one by sending product id to this function)
        if (
            checkNewItems &&
            (typeof checkItemsStock === 'function') &&
            (typeof query_stock_in_cache === 'boolean' && query_stock_in_cache === true)
        ) {
            checkItemsStock();
            return;
        }
        // Refreshes the display of current products
        if (refreshCurrentItems) {
            refreshProductsDisplayWithStock();
            return;
        }
        // Updates the display of a specific product
        if (productId) {
            if (
                (typeof array_stock_product == 'undefined' || typeof array_stock_product[productId] == 'undefined' || array_stock_product[productId] === null) &&
                (typeof checkItemsStock === 'function') &&
                (typeof query_stock_in_cache === 'boolean' && query_stock_in_cache === true)
            ) {
                checkItemsStock();
                return;
            }
            const stock = array_stock_product[productId];
            const $items = $(`.stockToCheck[data-product-id-stock=${productId}]`);

            if ($items.length) {
                // The same product can be on the page multiple times (after a color change) so we update every occurrence
                $items.each(function () {
                    const item = $(this);

                    processDisplayProductInList(item, stock);
                });
            }
        }
    }

    function processDisplayProductInList(obj, result) {
        var has_stock = false;

        // Loop through the stock information and update the has_stock variable to display or hide the unavailable block
        // And gray out sizes without stock
        Object.keys(result).forEach(function(color_id) {
            Object.keys(result[color_id]).forEach(function(size_id) {
                let productId = obj.find('.product-infos-form').data('productId');
                let targetId = 'prod_size_' + productId + '_' + size_id;
                if (!isNaN(color_id) && result[color_id][size_id]) {
                    has_stock = true;
                    obj.find('[name="prod_size"]').filter('[value="' + size_id + '"]').removeClass('disabled');
                    obj.find('label[for="' + targetId + '"]').removeAttr('no-stock');
                    obj.find('label[for="' + targetId + '"]').removeAttr('has-alert');
                } else {
                    obj.find('[name="prod_size"]').filter('[value="' + size_id + '"]').addClass('disabled');
                    obj.find('label[for="' + targetId + '"]').attr('no-stock', '');
                    obj.find('label[for="' + targetId + '"]').attr('has-alert', '');
                }
            });
        });

        let text = Translator.translate('item_add_cart');
        let label2 = obj.find('.eclat.rect');
        if (label2.length > 0) {
            if (!has_stock || result.stock_quantite <= 0) {
                // eclat no stock
                obj.find('.no_stock').removeClass('cache');

                // If no stock: remove the product in cross-sell
                if (obj.closest('.associations-wrapper, .recently-browsed-slider, #buyTogetherSlider').length > 0) {
                    obj.remove();
                    return;
                }
            } else if (result.stock_quantite < 4) {
                // eclat limite
                obj.find('.limited_stock').removeClass('cache');
            } else {
                // eclat automatic
                if (obj.find('.automatic').length > 0) {
                    obj.find('.automatic').removeClass('cache');
                }
            }
        }

        if (!has_stock) {
            if (result.enableAlertStock) {
                text = Translator.translate('item_alert_receive');
            } else {
                text = Translator.translate('item_nostock');
            }
        }

        obj.find('button.item-add-cart-button').text(text);
    }

    /**
     * Get the stock information for all new product IDs
     * and send the custom event to update the stock information for some or all products
     *
     * @param {boolean} refreshAllItems Whether to fetch stock again for every rendered product.
     * @returns {void}
     */
    function checkItemsStock(refreshAllItems = false) {

        var productIdsAll = $.find('.product-infos-form');
        var productIdsNew = [];
        if (productIdsAll.length) {
            // On a product page - we also collect cross sell items (.item-product)
            productIdsAll = $.find('.item-product');
            for (var newIndexId = 0; newIndexId < productIdsAll.length; newIndexId++) {
                currentProductId = productIdsAll[newIndexId].dataset.productIdStock;

                // Skip products already in cache, unless we are doing a full refresh.
                // Also skip products already being fetched (pendingProductIds) to avoid duplicate requests.
                if (
                    (array_stock_product[currentProductId] == undefined && !pendingProductIds.has(currentProductId)) ||
                    refreshAllItems
                ) {
                    productIdsNew.push(currentProductId);
                }
            }
        } else {
            // On a listing/category page there is no product form — only .item-product cards.
            productIdsAll = $.find('.item-product');
            for (var indexId = 0; indexId < productIdsAll.length; indexId++) {
                var currentProductId = productIdsAll[indexId].dataset.productIdStock;

                // Skip products already in cache or already being fetched...
                if (array_stock_product[currentProductId] == undefined && !pendingProductIds.has(currentProductId)) {
                    productIdsNew.push(currentProductId);
                }
            }
        }

        const cleanProductIds = ids => Array.from(new Set(ids)).filter(id => id != null && id !== '');

        // Keep only unique, non-empty product IDs.
        productIdsAll = cleanProductIds(productIdsAll.map(item => item.dataset.productIdStock));
        productIdsNew = cleanProductIds(productIdsNew);

        // Filters replace the product cards in the DOM. Reapply cached stock data
        // to the new elements without making another AJAX request.
        if (!refreshAllItems) {
            productIdsAll.forEach(productId => {
                if (array_stock_product[productId] != null) {
                    updateProductDisplayWithStock(productId);
                }
            });
        }

        // No new product IDs found
        if (productIdsNew.length === 0) {
            return;
        }

        var data = {produit_id: productIdsNew};
        // Define the isGlobalEActive variable, if not defined
        isGlobalEActive = refreshIsGlobalEActive() ? true : false; 
        
        if (isGlobalEActive) {
            data.warehouse_only = 1;
        }
        
        // Mark the product IDs as pending to prevent duplicate requests
        productIdsNew.forEach(id => pendingProductIds.add(id));

        var colisagePromise = $.ajax({
            url : path_relative_root + 'ajax_get_colisages_states_by_color_size.php',
            type : 'POST',
            data : data
        });

        colisagePromise.then(function (response) {
            try {
                response = $.parseJSON(response);
            } catch (e) {
                console.error("checkItemsStock - Failed to parse response to JSON", e);
                return;
            }

            // Remove the product IDs from pending set, as we have received a response (success or not)
            productIdsNew.forEach(id => pendingProductIds.delete(id));

            if (response?.success) {
                const result = response.result;

                Object.assign(array_stock_product, result || {});

                // Mark every missing or null response as empty to avoid querying it again indefinitely.
                productIdsNew.forEach(productId => {
                    if (array_stock_product[productId] == null) {
                        array_stock_product[productId] = {};
                    }
                });

                // Dispatch an event per product ID to update the display of each product
                productIdsNew.forEach(productId =>
                    window.dispatchEvent(new CustomEvent('updateItemStock', {
                        detail: { productId, stock: array_stock_product[productId] }
                    }))
                );
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.error("checkItemsStock - AJAX request failed", { jqXHR, textStatus, errorThrown });
            // On failure, we remove the product IDs from pending set to allow retrying later
            productIdsNew.forEach(id => pendingProductIds.delete(id));
        });
    }


    // Iterates over all cached products and re-renders their display.
    // Called when the user changes the color/variant so the UI reflects the latest cached data.
    function refreshProductsDisplayWithStock() {
        if (typeof array_stock_product != 'undefined') {
            Object.keys(array_stock_product).forEach(productId => (updateProductDisplayWithStock(productId)));
        }
    }
}
